import React ,{useState,useEffect}from "react";
import useNext, { TopologyConfig, TopologyData } from "react-next-ui";
import "react-next-ui/build/css/next.min.css";

//warehouse
import Service from "src/api/Service";
import customer from '../../assets/images/nextIcons/Customer.png';
import customerA from '../../assets/images/nextIcons/CustomerA.png';
import factory from '../../assets/images/nextIcons/factory.png';
import factoryA from '../../assets/images/nextIcons/factoryA.png';
import warehouse from '../../assets/images/nextIcons/warehouse.png';
import warehouseA from '../../assets/images/nextIcons/warehouseA.png';
import depot from '../../assets/images/nextIcons/Depot.png';
import depotA from '../../assets/images/nextIcons/DepotA.png';
import retailer from '../../assets/images/nextIcons/retailer.png';
import retailerA from '../../assets/images/nextIcons/retailerA.png';

import './css/next.css';
import { Modal, Button } from 'react-bootstrap';
import AlertComponent from './AlertComponent';

const Next = () => {
    const [visible, setVisible] = useState(false);
    const [Alert, setAlert] = useState([]);
  const [nodeColor, setNodeColor] = useState("red");
  const [isLoading, setisLoading] = useState(true);
  const [dataSet, setdataSet] = useState({});
  const sampleTopology: TopologyData ={
    "nodes": [
        
    ],
    "links": [
       
    ]
};





  const [topology, setTopology] = useState(sampleTopology);


  const sampleConfig: NxTopologyConfig = {
    nodeDraggable:false,
    nodeConfig: {
			      label: "model.name",
            iconType: "model.device_type",
            color: "model.color"       
		},
    linkConfig: {
      linkType: "straight",
      color: "model.color",
      label: "model.name"
    },
    width:1300,
    height: 640,
    showIcon: true,
    identityKey: "id",
    node:false
  };


  const [config, setsampleConfig] = useState(sampleConfig);
  let i = 1;
  const sampleEvtHandlers: EventHandlers = {
    
    clickLink: (sender, event) => {
     // Display an alert to the user
     window.nx.define('MyLinkTooltip', window.nx.ui.Component, {
      properties: {
                link: {},
                topology: {}
        },

      view: {
        content: [{
           tag: 'p',

                content: [{
                  tag: 'b',
                    content: 'Source:'

                }, 
                {

                  tag: 'span',
                    content: '{#link.model.source.name}'

                }]

              }, 
              {

                tag: 'p',

                  content: [{
                     tag: 'b',
                      content: 'Target:'

                  }, 
                  {
                    tag: 'span',
                      content: '{#link.model.target.name}'

                  }]

                }]

      }

  }); 
  nxApp.tooltipManagerConfig( {

    nodeTooltipContentClass: 'MyNodeTooltip',

    linkTooltipContentClass: 'MyLinkTooltip'

  } );
    },
    clickNode:(sender,event)=>{     
      var data={
        id:event.id(),
        name:event.label()
      }
      setAlert(data);
      setVisible(!visible);

     
             console.log("call------------");
              window.nx.define('MyLinkTooltipnode', window.nx.ui.Component, {
                properties: {
                         node: {},
                          topology: {}
                  },
          
                view: {
                  content: [{
                    tag: 'p',
          
                          content: [{
                            tag: 'b',
                              content: '{#node.model.name}:'
          
                          }]
          
                        }]
          
                }
          
            }); 
          nxApp.tooltipManagerConfig( {
        
            nodeTooltipContentClass: 'MyLinkTooltipnode',
        
            // linkTooltipContentClass: 'MyLinkTooltip'
        
          } );
    

    },
    pressA: (sender, event) => {
      // Insert Data

      sender.addNode({ id: i++ });
    },
  
    // dragNode:(sender , event)=>{
    //   console.log(sender);
    //   console.log(event);

    // },
    dragNodeEnd:(sender , event)=>{
      console.log("dragNodeEnd");
      // console.log(event);
      // console.log(event.id());
      // console.log(event.x());
      // console.log(event.y());
      var data={
        id:event.id(),
        name:event.label()
      }
      setAlert(data);
      setVisible(!visible);
    }

  };




  const { NextUI,nxApp  } = useNext({

    topologyData: topology,
    topologyConfig: config,
    eventHandlers: sampleEvtHandlers,  
    style: { height: "19vh", width: "65vw"},
      // callback: afterLoad,
   
  });


  
    
  
     if(window.nx != undefined && !isLoading ){
     
      try{
        nxApp.registerIcon("customer", customer, 40, 48);
        nxApp.registerIcon("customera", customerA, 40, 48);
        nxApp.registerIcon("factory", factory, 70, 48);
        nxApp.registerIcon("factorya", factoryA, 70, 48);
        nxApp.registerIcon("warehouse", warehouse, 70, 48);
        nxApp.registerIcon("warehousea", warehouseA, 70, 48);
        nxApp.registerIcon("depot", depot, 70, 48);
        nxApp.registerIcon("depota", depotA, 70, 48);
        nxApp.registerIcon("retailer", retailer, 70, 48);
        nxApp.registerIcon("retailera", retailerA, 70, 48);
     
      }catch(e){
        window.window.nx.graphic.Icons.registerIcon("customer", customer, 40, 48);
        window.window.nx.graphic.Icons.registerIcon("customera", customerA, 40, 48);
        window.window.nx.graphic.Icons.registerIcon("factory", factory, 70, 48);
        window.window.nx.graphic.Icons.registerIcon("factorya", factoryA, 70, 48);
        window.window.nx.graphic.Icons.registerIcon("warehouse", warehouse, 70, 48);
        window.window.nx.graphic.Icons.registerIcon("warehousea", warehouseA, 70, 48);
        window.window.nx.graphic.Icons.registerIcon("depot", depot, 70, 48);
        window.window.nx.graphic.Icons.registerIcon("depota", depotA, 70, 48);
        window.window.nx.graphic.Icons.registerIcon("retailer", retailer, 70, 48);
        window.window.nx.graphic.Icons.registerIcon("retailera", retailerA, 70, 48);
     
      }
  
     }
  
     const fetchData = async () => {

      await Service.get("alert_dashboard/networklocation",(status,data)=>{
        if(status==200){
          let temp = {};
          temp.nodes = [];
          temp.links = [];
          console.log(data);
          data.map((ele=>{
            var  Icon= ele['alertFlag']=='A'? ele['iconType']+'a':ele['iconType'];           
            var  color= ele['alertFlag']=='A'? 'black' :'black';           
            temp.nodes.push({ id: parseInt(ele['tableId']), x:parseInt( ele['x']), y: parseInt(ele['y']), name: ele['name'], device_type:Icon, color:color  });
            
            if(ele['target'] != null){
              JSON.parse(ele['target']).forEach(function (item, index) {
                var tid=  JSON.parse(ele['target']);
                var color= ele['linkColor']==null? 'black' :"#3D84C6"; 
                temp.links.push({ source: parseInt(ele['tableId']), target: parseInt( tid[index]),color:color});
              });
            }        
          }));
         
          setTopology(temp);
          setisLoading(false);
         
  
          
     }
    });
  
    }
  
    useEffect(()=>{
      fetchData();
   
   
   }, [window.nx]);
  let k = 1;
  const clickHandlerAddNode = () => {
    nxApp?.insertData({ nodes: [{ id: 50 * k++ }] });
  };

  const clickHandlerAddLink = () => {
    nxApp?.insertData({ links: [{ source: 1, target: 2 }] });
  };

  const clickHandlerNewTopology = () => {
    setTopology({
      nodes: [{ id: 1 }, { id: 2 }, { id: 8 }],
      links: [{ source: 1, target: 2 }],
    });
  };

  const clickHandlerChangeColor = () => {
    setNodeColor((nodeColor) => (nodeColor === "red" ? "blue" : "red"));
    console.log(nodeColor);
  

    nxApp?.eachNode((node) => {
      if (node.id() === 1) {
        node.color(nodeColor);
      }
    });
  };

  if(isLoading){
    return (
      <>
        Wait
      </>
    );
  }
console.log(Alert);
  return (
    <>
      {NextUI}
      
      <Modal show={visible}  size="lg" >
                <Modal.Header closeButton onClick={() => setVisible(!visible)} >
                  <Modal.Title style={{marginLeft: 'auto'}}>{Alert['name']}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <AlertComponent id={Alert['id']}/>

                </Modal.Body>

              </Modal>
    </>
  );
};

export default Next;